import React from "react";
import { Container, Table, Col } from "react-bootstrap";

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};

function Work() {
  return (
    <div>

<div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">Work Experience</h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>



        <br />
          <br />  <br />
          <br />
        <Container>
          <h3 className="text-center">
            Work experience outside the University system
          </h3>
          <br />
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Post</th>
                <th>Institution</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Lecturer</td>
                <td>
                  Department of Science Technology, Yaba College of
                  Technology,Yaba Lagos (For NYSC year)
                </td>
                <td>1987 – 1988 (NYSC year)</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Senior Physics Tutor</td>
                <td>Egbado College, Ilaro, Ogun State</td>
                <td>1989 – 1990</td>
              </tr>
            </tbody>
          </Table>
          <br />
          <br />

          <h3 className="text-center">
            Work Experience in Ondo State University, Ado-Ekiti, and Adekunle
            Ajasin University, Akungba-Akoko
          </h3>
          <br />
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Username</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Assistant Lecturer</td>
                <td>
                  Department of Physics, Ondo State University, Ado-Ekiti{" "}
                </td>
                <td>1990-1994</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Lecturer Grade II</td>
                <td>Department of Physics, Ondo State University, Ado-Ekiti</td>
                <td>1994-1997</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Lecturer Grade 1</td>
                <td>
                  Department of Physics, Ondo State University, Ado – Ekiti
                </td>
                <td>1997-2000</td>
              </tr>

              <tr>
                <td>4</td>
                <td>Senior Lecturer</td>
                <td>
                  Department of Physics & Electronics, Adekunle Ajasin
                  University, Akungba- Akoko{" "}
                </td>
                <td>2000-2004</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Reader</td>
                <td>
                  Department of Physics & Electronics,Adekunle Ajasin
                  University, Akungba- Akoko{" "}
                </td>
                <td>2004-2007</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Professor</td>
                <td>
                  Department of Physics & Electronics, Adekunle Ajasin
                  University, Akungba – Akoko{" "}
                </td>
                <td>2007 to date</td>
              </tr>
            </tbody>
          </Table>
        </Container>
        <br />
          <br />
      </div>
    </div>
  );
}

export default Work;
